import { Component, OnInit } from '@angular/core';
import { RouterService } from '@app/routing/router.service';

@Component({
  selector: 'portal-initial-routing',
  templateUrl: './initial-routing.component.html',
  styleUrls: ['./initial-routing.component.scss'],
  standalone: false,
})
export class InitialRoutingComponent implements OnInit {
  constructor(private routerService: RouterService) {}

  ngOnInit() {
    this.routerService.navigateToInitialRoute();
  }
}
